import React from 'react';
import { Icon, TextButton } from '@oneaudi/unified-web-components';
import { ButtonWrapper, ForwardIconWrapper, IconWrapper } from './Impel360CTA.style';

interface Impel360CTAProps {
  isVisible: boolean;
  label: string;
  color: string;
  isNew: boolean;
  isT3: boolean;
}

const Impel360CTA: React.FC<Impel360CTAProps> = ({ isVisible, label, color, isNew, isT3 }) => {
  const labelText = !label || label.length === 0 ? 'view vehicle tour' : label;
  const labelTextFormatted = labelText.charAt(0).toUpperCase() + labelText.slice(1);

  return (
    <ButtonWrapper isVisible={isVisible} color={color} isNew={isNew} isT3={isT3}>
      <TextButton
        id="vendorIntegrations__impel"
        variant="primary"
        size="sm"
        type="button"
        aria-label="View vehicle tour"
        data-testid="impel360-cta"
        onClick={() => {}}
      >
        <IconWrapper color={color}>
          <Icon name="view-360" size="s" />
        </IconWrapper>
        {labelTextFormatted}
        <IconWrapper color={color}>
          <ForwardIconWrapper>
            <Icon name="forward" size="xs" />
          </ForwardIconWrapper>
        </IconWrapper>
      </TextButton>
    </ButtonWrapper>
  );
};
export default Impel360CTA;
